export const KEYS_THAT_OPEN_NATIVE_PICKER = new Set([' ', 'Spacebar'])
